import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'page-description',
  templateUrl: './page-description.component.html',
  styleUrls: ['./page-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PageDescriptionComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
